// src/pages/ComingSoonPage.js
import React from 'react';
import { ShieldCheck } from 'lucide-react';

export default function ComingSoonPage({ title = 'Coming Soon', description }) {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-10 shadow-sm">
      <div className="flex max-w-3xl items-start gap-5">
        <div className="rounded-2xl bg-orange-50 p-4 text-orange-600 ring-1 ring-orange-100">
          <ShieldCheck className="h-8 w-8" />
        </div>

        <div>
          <h1 className="text-2xl font-bold text-slate-950">{title}</h1>
          <p className="mt-2 text-slate-600">
            {description ||
              'This module is part of the upgraded Privacy Data Operations Platform and will be implemented in the next iteration.'}
          </p>
        </div>
      </div>
    </div>
  );
}